import { load } from "@nextgisweb/jsrealm/i18n/catalog";
load("raster_mosaic", {"":{"File '{}' has an invalid extension.":["У файла '{}' неправильное расширение."],"Upload":["Загрузить"],"Rasters":["Растры"]}})